import loadable from '@loadable/component';

export const OrgDashboardCheckoutCartPageLoadable = loadable(
  () => import('./OrgDashboardCheckoutCartPage'),
  { resolveComponent: (module) => module.OrgDashboardCheckoutCartPage },
);
